import { render, staticRenderFns } from "./FacebookDeleteDataView.vue?vue&type=template&id=02a63f4e&scoped=true"
import script from "./FacebookDeleteDataView.vue?vue&type=script&lang=js"
export * from "./FacebookDeleteDataView.vue?vue&type=script&lang=js"
import style0 from "./FacebookDeleteDataView.vue?vue&type=style&index=0&id=02a63f4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02a63f4e",
  null
  
)

export default component.exports